import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
export const UiIconSmmplannerLogo = (props) => (_jsx(SvgIcon, Object.assign({ viewBox: "0.1 0.4 27.7 26.7" }, props, { children: _jsx("path", { d: "M0,18.42855V12.69418L22.1725.38579h5.02032L21.48421,27.557h-5.1128L20.78569,6.85713Z" }) })));
//# sourceMappingURL=ui_icon_smmplanner_logo.js.map